import { graphql } from 'react-relay';

// Export the generated types
export * from './__generated__/Auth_LoginClients_Query.graphql';

// Define the GraphQL query for getting Google provider information
export const LoginClientsQuery = graphql`
  query Auth_LoginClients_Query {
    loginClients {
      authorizationUrl
      clientId
      provider
      isEnabled
      domains
    }
  }
`;
